import PropTypes from 'prop-types';
import { useState } from 'react';
import { Paper, Tab, Tabs, } from '@mui/material';
import { TabPanel } from '../../../../reusable-components/tab-panel';
import FacilityAccountsTable from '../facility-accounts/FacilityAccountsTable';
import BookingAccountTable from './BookingAccounts/BookingAccountTable';

VendorAccountsTab.propTypes = {
  selectedRow: PropTypes.object,
};

export default function VendorAccountsTab({ selectedRow }) {
  const [tabIndex, setTabIndex] = useState(0);

  return (
    <Paper sx={{ px: 2, boxShadow: ' 0px 2px 4px 1px rgba(0, 0, 0, 0.2)' }}>
      <Tabs value={tabIndex} sx={{ mb: 1 }}>
        <Tab label="Facility Accounts" onClick={() => setTabIndex(0)} />
        <Tab label="Booking Accounts" onClick={() => setTabIndex(1)} />
      </Tabs>
      <TabPanel value={tabIndex} index={0}>
        <FacilityAccountsTable selectedRow={selectedRow} />
      </TabPanel>
      <TabPanel value={tabIndex} index={1}>
        <BookingAccountTable selectedRow={selectedRow} />
      </TabPanel>
    </Paper>
  );
}
